/**
 * Moneda que debe quedar en el alta de un pedido al elegir proveedor.
 *
 * Se propone la del proveedor **solo si el campo sigue en la propuesta anterior** (o vacío): si el
 * usuario ya eligió otra moneda, se respeta. Sin esta regla, el pedido a un proveedor que factura en
 * yuanes salía en euros sin avisar.
 */
export function proponerMoneda(
  actual: string,
  propuesta: string,
  delProveedor: string | null | undefined
): { currency: string; propuesta: string } {
  const nueva = (delProveedor ?? 'EUR').toUpperCase();
  if (actual === '' || actual === propuesta) return { currency: nueva, propuesta: nueva };
  return { currency: actual, propuesta: propuesta };
}

/** Al volver a «Elige proveedor…»: la moneda vuelve al euro si seguía siendo la propuesta. */
export function limpiarMoneda(actual: string, propuesta: string): { currency: string; propuesta: string } {
  if (actual === '' || actual === propuesta) return { currency: 'EUR', propuesta: 'EUR' };
  return { currency: actual, propuesta: 'EUR' };
}
